
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form10";
const form10State = namespace("Form10");

import "@/store/modules/forms/form11";
const form11State = namespace("Form11");

import "@/store/modules/forms/form12";
const form12State = namespace("Form12");

import "@/store/modules/forms/form13";
const form13State = namespace("Form13");

import "@/store/modules/forms/form14";
const form14State = namespace("Form14");

import "@/store/modules/forms/form15";
const form15State = namespace("Form15");

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class ChecklistOrders extends Vue {    

    @form10State.Action
    public UpdateCurrentOrderSingleJusticeId!: (newCurrentOrderSingleJusticeId: string) => void

    @form11State.Action
    public UpdateCurrentOrderMultipleJusticesId!: (newCurrentOrderMultipleJusticesId: string) => void
	 
    @form12State.Action
    public UpdateCurrentOrderToVarySingleJusticeId!: (newCurrentOrderToVarySingleJusticeId: string) => void

    @form13State.Action
	public UpdateCurrentConsentOrderExtendTimeId!: (newCurrentConsentOrderExtendTimeId: string) => void

    @form14State.Action
    public UpdateCurrentConsentOrderRemoveInactiveId!: (newCurrentConsentOrderRemoveInactiveId: string) => void

    @form15State.Action
    public UpdateCurrentConsentOrderId!: (newCurrentConsentOrderId: string) => void
	    
    inactiveButtonClass = "bg-secondary text-white"; 
    activeButtonClass = "bg-success text-white"; 
   

    responseOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    consentOrderTypeOptions = [
        {text: 'extend the time to file a document (Form 13)', value: 13},
        {text: 'remove an appeal from the inactive list (Form 14)', value: 14},
        {text: 'in the case of any other consent order (Form 15)', value: 15}
    ];

    dataReady = false;
    stepStyle = "font-size: 2rem;";

    consentOrder = null;
    consentOrderType = 0;
    singleJusticeOrder = null;
    multipleJusticesOrder = null;
    varyOrder = null;

    displayConsentOrderType = false;
    displaySingleJusticeOrder = false;
    displayMultipleJusticesOrder = false;
    displayVaryOrder = false;
    displayForm12 = false;    
    displayForm10 = false;    
    displayForm11 = false;
    displayForm13 = false;
    displayForm14 = false;
    displayForm15 = false;

    update = 0;
    
    mounted(){

        this.dataReady = false;
        this.consentOrder = null;
        this.consentOrderType = 0;
        this.singleJusticeOrder = null;
        this.multipleJusticesOrder = null;
        this.varyOrder = null;
        this.resetValues();
        this.dataReady = true;       

    }

    public resetValues(){
        this.displayConsentOrderType = false;
        this.displaySingleJusticeOrder = false;
        this.displayMultipleJusticesOrder = false;
        this.displayVaryOrder = false;
        this.displayForm12 = false;    
        this.displayForm10 = false;    
        this.displayForm11 = false;
        this.displayForm13 = false;
        this.displayForm14 = false;
        this.displayForm15 = false;
    }

    public updateConsentOrder(){
        this.resetValues();
        this.displayConsentOrderType = this.consentOrder;   
        this.displaySingleJusticeOrder = this.consentOrder == false;     
        this.update++;
    }

    public updateConsentOrderType(){  
        this.resetValues();
        this.displayConsentOrderType = true;     
        this.displayForm13 = this.consentOrderType == 13;
        this.displayForm14 = this.consentOrderType == 14;
        this.displayForm15 = this.consentOrderType == 15;        
        this.update++;
    }

    public updateSingleJusticeOrder(){
        this.resetValues();
        this.displaySingleJusticeOrder = true;
        this.displayForm10 = this.singleJusticeOrder; 
        this.displayMultipleJusticesOrder = this.singleJusticeOrder == false;        
        this.update++;
    }

    public updateMultipleJusticesOrder(){
        this.resetValues();
        this.displaySingleJusticeOrder = true;
        this.displayMultipleJusticesOrder = true;
        this.displayVaryOrder = this.multipleJusticesOrder;        
        this.update++;
    }  

    public updateVaryOrder(){
        this.resetValues();
        this.displaySingleJusticeOrder = true;
        this.displayMultipleJusticesOrder = true;
        this.displayVaryOrder = true; 
        this.displayForm11 = this.varyOrder == false;
        this.displayForm12 = this.varyOrder;         
        this.update++;
    }

    public startNewForm10Document(){
        this.UpdateCurrentOrderSingleJusticeId(null);
        this.$router.push({name: "start-form10" });
    }

    public startNewForm11Document(){
        this.UpdateCurrentOrderToVarySingleJusticeId(null);
        this.$router.push({name: "start-form11" });
    }    

    public startNewForm12Document(){
        this.UpdateCurrentOrderToVarySingleJusticeId(null);
        this.$router.push({name: "start-form12" });
    }

    public startNewForm13Document(){
        this.UpdateCurrentConsentOrderExtendTimeId(null);
        this.$router.push({name: "start-form13" });
    }

    public startNewForm14Document(){
        this.UpdateCurrentConsentOrderRemoveInactiveId(null);
        this.$router.push({name: "start-form14" });
    }

    public startNewForm15Document(){
        this.UpdateCurrentConsentOrderId(null);
        this.$router.push({name: "start-form15" });
    }

}
